import React, { useContext } from 'react';
import { getFotbollPlayUrl } from '../../../utils/matchevents';
import { UserContext } from '../../../context/user-context';

function GameEventShot({ event, byHomeTeam, isPlayable }) {
  const { playVideo } = useContext(UserContext);
  const { playerName, minuteWithStoppageTime, description, video } = event;
  const thumbnail = video?.thumbnail;
  const fotbollPlayUrl = getFotbollPlayUrl(video);

  if (!byHomeTeam) {
    return (
      <div className="match-timeline__row">
        <div className="match-timeline__team match-timeline__team--left match-timeline__team--empty" />
        <div className="match-timeline__time text-small fw-bold">
          {minuteWithStoppageTime}
        </div>
        <div className="match-timeline__team match-timeline__team--right">
          <div className="match-timeline__connector" />
          {isPlayable && (
            <div
              className="video__item video__item--timeline text-decoration-none"
              onClick={() => playVideo(video)}
            >
              <img src={thumbnail} alt="" />
              <div className="video__info p-3">
                <div className="d-flex gap-2 align-items-end">
                  <div className="timeline-event timeline-event--icon timeline-event--comp-blue-3">
                    <img
                      width="17"
                      height="17"
                      src="/wp-content/themes/sef-leagues/images/event-free-kick-logo.svg"
                      alt=""
                    />
                  </div>
                  <p className="text-small d-flex flex-column">
                    <span className="fw-bold">Avslut</span>
                    <span className="order-1">{description}</span>
                  </p>
                </div>
              </div>
            </div>
          )}
          {!isPlayable && (
            <div className="timeline-event timeline-event--comp-blue-3 gap-2">
              <span className="order-1">{description}</span>
              <div className="d-flex flex-column">
                <img
                  src="/wp-content/themes/sef-leagues/images/event-free-kick-logo.svg"
                  alt="skott"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="match-timeline__row">
      <div className="match-timeline__team match-timeline__team--left">
        {isPlayable && (
          <div
            className="video__item video__item--timeline text-decoration-none"
            onClick={() => playVideo(video)}
          >
            <img src={thumbnail} alt="" />
            <div className="video__info p-3">
              <div className="d-flex gap-2 align-items-end">
                <div className="timeline-event timeline-event--icon timeline-event--comp-blue-3">
                  <img
                    width="17"
                    height="17"
                    src="/wp-content/themes/sef-leagues/images/event-free-kick-logo.svg"
                    alt=""
                  />
                </div>
                <p className="text-small d-flex flex-column">
                  <span className="fw-bold">Avslut</span>
                  <span className="order-1">{description}</span>
                </p>
              </div>
            </div>
          </div>
        )}
        {!isPlayable && (
          <div className="timeline-event timeline-event--comp-blue-3 gap-2">
            <span className="order-1 text-lg-end">{description}</span>
            <div className="d-flex flex-column order-0 order-lg-1">
              <img
                src="/wp-content/themes/sef-leagues/images/event-free-kick-logo.svg"
                alt="skott"
              />
            </div>
          </div>
        )}
        <div className="match-timeline__connector" />
      </div>
      <div className="match-timeline__time text-small fw-bold">
        {minuteWithStoppageTime}
      </div>
      <div className="match-timeline__team match-timeline__team--right match-timeline__team--empty" />
    </div>
  );
}

export default GameEventShot;
